import m from "mithril";
interface Attrs {
    templateId:string
}
export default function TemplateContentFrame(): m.Component<Attrs> {
    return {
        oncreate(vnode) {            
            let templateElem:any = document.getElementById(vnode.attrs.templateId);
            if(templateElem != null) {
                let clonedTemplate = templateElem.content.cloneNode(true);    
                vnode.dom.appendChild(clonedTemplate);
            }
        },

        view(vnode) {
            return m("div", {},[
                m("div", {})
            ]) 
        }
    }
}